import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import axios from 'axios'
import Breadcrumbs from '../components/Breadcrumbs'

export default function Login() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent'>('idle')

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setStatus('sending')
    try {
      await axios.post('/api/auth/request-link', { email })
      setStatus('sent')
    } catch {
      // Avoid user enumeration: show same success UI
      setStatus('sent')
    }
  }

  return (
    <div className="min-h-screen pb-24">
      <Breadcrumbs items={[{ key: 'login' }]} />

      <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="text-center mb-10"
        >
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 text-primary mb-6">
            <span className="material-icons text-3xl">lock</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold mb-3">{t('auth.loginTitle')}</h1>
          <p className="text-slate-600 dark:text-slate-400">{t('auth.loginSubtitle')}</p>
        </motion.div>

        <motion.form
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          onSubmit={submit}
          className="bg-white dark:bg-slate-800 rounded-2xl p-6 sm:p-8 shadow-xl border border-slate-200 dark:border-slate-700"
        >
          {status !== 'sent' ? (
            <>
              <label htmlFor="email" className="block text-sm font-semibold mb-2">
                {t('auth.email')} *
              </label>
              <input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
              />
              <button
                type="submit"
                disabled={status === 'sending'}
                className="mt-5 w-full px-6 py-4 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {status === 'sending' ? t('auth.sending') : t('auth.sendLink')}
              </button>
              <p className="mt-4 text-xs text-slate-500 dark:text-slate-400">
                {t('auth.noEnumerationNote')}
              </p>
            </>
          ) : (
            <div className="text-center space-y-3">
              <p className="text-lg font-semibold">{t('auth.checkEmailTitle')}</p>
              <p className="text-slate-600 dark:text-slate-400">{t('auth.checkEmailBody')}</p>
            </div>
          )}
        </motion.form>
      </div>
    </div>
  )
}
